import React, { useEffect } from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';

// Include the Poppins font
const PromoComponent = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  const containerStyle = {
    backgroundColor: 'black',
    color: 'white',
    textAlign: 'center',
    width: '100%',
    height: '50vh',
    margin: '0',
    paddingTop: '80px', 
    paddingBottom: '80px', 
    fontFamily: "'Poppins', sans-serif"
  };

  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    color: 'black',
    border: 'none',
    borderRadius: '5px',
    padding: '10px 20px',
    margin: '20px',
    textDecoration: 'none',
    fontSize: '16px',
    cursor: 'pointer'
  };

  const responsiveContainerStyle = {
    ...containerStyle,
    padding: '20px',
    height: 'auto',
  };

  return (
    <div style={responsiveContainerStyle}>
      <h1 style={{color: 'white'}}>Discover Proteus Security News</h1>
      <p style={{color: 'white'}}>Your source for the latest security, business and technology news and updates. Stay informed!</p>
      <div>
        <a href="https://apps.apple.com/gb/app/proteus-news/id6742108263" style={buttonStyle}>
          <FaApple size={24} style={{ marginRight: '10px' }} />
          App Store
        </a>
      </div>
    </div>
  );
};

export default PromoComponent;